module.exports = __webpack_public_path__ + "static/media/vue js.318200c3.svg";